(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cookie-consent"] && !Shopify.designMode) return;
  try {
    (function () {
    var STORAGE_KEY = 'lk_cookie_consent_v1';
    var banner = document.querySelector('[data-cookie-consent]');

    if (!banner) {
      return;
    }

    function readConsent() {
      try {
        return localStorage.getItem(STORAGE_KEY);
      } catch (error) {
        return null;
      }
    }

    function writeConsent(value) {
      try {
        localStorage.setItem(STORAGE_KEY, value);
      } catch (error) {
        /* ignore */
      }
      document.documentElement.classList.add('cookie-consent-resolved');
    }

    function hideBanner() {
      banner.hidden = true;
    }

    function showBanner() {
      if (readConsent()) {
        document.documentElement.classList.add('cookie-consent-resolved');
        hideBanner();
        return;
      }

      banner.hidden = false;
    }

    function applyShopifyConsent(accepted) {
      if (!window.Shopify || !window.Shopify.loadFeatures) {
        return;
      }

      window.Shopify.loadFeatures(
        [
          {
            name: 'consent-tracking-api',
            version: '0.1',
          },
        ],
        function (error) {
          if (error || !window.Shopify.customerPrivacy) {
            return;
          }

          if (accepted) {
            window.Shopify.customerPrivacy.setTrackingConsent(
              {
                analytics: true,
                marketing: true,
                preferences: true,
                sale_of_data: false,
              },
              function () {}
            );
          } else {
            window.Shopify.customerPrivacy.setTrackingConsent(
              {
                analytics: false,
                marketing: false,
                preferences: false,
                sale_of_data: false,
              },
              function () {}
            );
          }
        }
      );
    }

    function acceptCookies() {
      writeConsent('accepted');
      applyShopifyConsent(true);
      hideBanner();
    }

    function declineCookies() {
      writeConsent('essential');
      applyShopifyConsent(false);
      hideBanner();
    }

    banner.querySelector('[data-cookie-accept]').addEventListener('click', acceptCookies);
    banner.querySelector('[data-cookie-decline]').addEventListener('click', declineCookies);

    showBanner();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["language-switcher"] && !Shopify.designMode) return;
  try {
    (function () {
    function stripLocalePrefix(pathname) {
      if (!pathname) return '/';
      if (pathname === '/en' || pathname === '/en/') return '/';
      if (pathname.indexOf('/en/') === 0) return pathname.slice(3) || '/';
      return pathname;
    }

    function bindLanguageSwitcher(root) {
      if (!root || root.dataset.languageSwitcherBound === 'true') return;
      root.dataset.languageSwitcherBound = 'true';

      var link = root.querySelector('[data-language-switch]');
      var form = root.querySelector('form');
      var returnInput = root.querySelector('[data-language-return]');

      if (!link || !form || !returnInput) return;

      link.addEventListener('click', function (event) {
        returnInput.value = stripLocalePrefix(window.location.pathname) + window.location.search;

        if (link.getAttribute('href') === window.location.pathname + window.location.search) {
          event.preventDefault();
          form.submit();
        }
      });
    }

    document.querySelectorAll('[data-language-switcher]').forEach(bindLanguageSwitcher);

    document.addEventListener('shopify:section:load', function (event) {
      event.target.querySelectorAll('[data-language-switcher]').forEach(bindLanguageSwitcher);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay-drawer-close"] && !Shopify.designMode) return;
  try {
    (function () {
    var CLOSE_MS = 400;

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function finishClose(drawer, onDone) {
      drawer.classList.remove('is-open', 'is-closing');
      drawer.setAttribute('aria-hidden', 'true');

      if (typeof onDone === 'function') {
        onDone();
      }
    }

    window.LKOverlayClose = {
      duration: CLOSE_MS,

      closeInstant: function (drawer) {
        if (!drawer) {
          return;
        }

        finishClose(drawer);
      },

      closeAnimated: function (drawer, onDone) {
        if (!drawer || !drawer.classList.contains('is-open')) {
          if (typeof onDone === 'function') {
            onDone();
          }
          return;
        }

        if (drawer.classList.contains('is-closing') || prefersReducedMotion()) {
          finishClose(drawer, onDone);
          return;
        }

        var panel = drawer.querySelector('.site-drawer__panel, .cart-drawer__panel');
        var done = false;

        function complete() {
          if (done) {
            return;
          }
          done = true;
          finishClose(drawer, onDone);
        }

        drawer.classList.add('is-closing');
        drawer.classList.remove('is-open');

        if (panel) {
          panel.addEventListener(
            'transitionend',
            function (event) {
              if (event.target === panel && event.propertyName === 'transform') {
                complete();
              }
            },
            { once: true }
          );
        }

        window.setTimeout(complete, CLOSE_MS + 80);
      }
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["page-transitions"] && !Shopify.designMode) return;
  try {
    (function () {
    var DURATION_MS = 400;
    var TRANSITION_KEY = 'lk_page_transition';
    var SHOP_RETURN_KEY = 'lk_return_to_shop';
    var ROOT_SELECTOR = '[data-page-transition-root]';

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function easeInOutSine(t) {
      return -(Math.cos(Math.PI * t) - 1) / 2;
    }

    function scrollToY(targetY, duration) {
      var startY = window.scrollY;
      var distance = targetY - startY;
      var startTime = performance.now();

      function step(now) {
        var elapsed = now - startTime;
        var progress = Math.min(elapsed / duration, 1);
        window.scrollTo(0, startY + distance * easeInOutSine(progress));

        if (progress < 1) {
          requestAnimationFrame(step);
        }
      }

      requestAnimationFrame(step);
    }

    function scrollToElement(element) {
      if (!element) {
        return;
      }

      var targetY = element.getBoundingClientRect().top + window.scrollY;
      scrollToY(targetY, DURATION_MS);
    }

    function updateShopHash() {
      var hash = '#landing-shop';
      if (window.location.hash !== hash) {
        history.replaceState(null, '', hash);
      }
    }

    function markShopReturnIfNeeded() {
      var shopSection = getShopTarget();
      if (!shopSection) {
        return;
      }

      var path = window.location.pathname || '/';
      if (path !== '/' && path !== '') {
        return;
      }

      var shopTop = shopSection.getBoundingClientRect().top + window.scrollY;
      if (window.scrollY >= shopTop - window.innerHeight * 0.35) {
        try {
          sessionStorage.setItem(SHOP_RETURN_KEY, '1');
        } catch (error) {}
      }
    }

    function initShopReturnScroll() {
      var shopSection = getShopTarget();
      if (!shopSection) {
        return;
      }

      var shouldScroll = window.location.hash === '#landing-shop';

      try {
        if (sessionStorage.getItem(SHOP_RETURN_KEY) === '1') {
          shouldScroll = true;
          sessionStorage.removeItem(SHOP_RETURN_KEY);
        }
      } catch (error) {}

      if (!shouldScroll) {
        return;
      }

      if (prefersReducedMotion()) {
        shopSection.scrollIntoView({ behavior: 'auto', block: 'start' });
      } else {
        scrollToElement(shopSection);
      }

      updateShopHash();

      try {
        sessionStorage.setItem('lk_landing_snap_released', '1');
      } catch (error) {}
    }

    function handleShopPopstate() {
      var shopSection = getShopTarget();
      if (!shopSection) {
        return;
      }

      var path = window.location.pathname || '/';
      if (path !== '/' && path !== '') {
        return;
      }

      if (window.location.hash === '#landing-shop') {
        if (prefersReducedMotion()) {
          shopSection.scrollIntoView({ behavior: 'auto', block: 'start' });
        } else {
          scrollToElement(shopSection);
        }

        try {
          sessionStorage.setItem('lk_landing_snap_released', '1');
        } catch (error) {}
        return;
      }

      window.scrollTo(0, 0);
    }

    function getShopTarget() {
      return document.getElementById('landing-shop');
    }

    function isShopScrollLink(link) {
      if (!link || !link.getAttribute) {
        return false;
      }

      if (link.classList.contains('landing-main__script-link--shop')) {
        return true;
      }

      var href = link.getAttribute('href') || '';
      return href === '#landing-shop' || href.indexOf('#landing-shop') !== -1;
    }

    function isSameDocumentShopLink(link) {
      var href = link.getAttribute('href') || '';
      if (href.charAt(0) === '#') {
        return Boolean(getShopTarget());
      }

      try {
        var url = new URL(link.href, window.location.origin);
        if (url.pathname !== window.location.pathname) {
          return false;
        }
        return url.hash === '#landing-shop' && Boolean(getShopTarget());
      } catch (error) {
        return false;
      }
    }

    function shouldPageTransition(link) {
      if (!link || link.hasAttribute('data-no-page-transition')) {
        return false;
      }

      if (link.target === '_blank' || link.hasAttribute('download')) {
        return false;
      }

      if (link.closest('[data-site-overlay-open], [data-cart-drawer], dialog, [data-filter-dropdown], [data-sort-dropdown]')) {
        return false;
      }

      var href = link.getAttribute('href');
      if (!href || href.charAt(0) === '#') {
        return false;
      }

      if (href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0 || href.indexOf('javascript:') === 0) {
        return false;
      }

      try {
        var url = new URL(link.href, window.location.origin);
        return url.origin === window.location.origin;
      } catch (error) {
        return false;
      }
    }

    function getTransitionDirection(link) {
      if (link.classList.contains('page-back-tab') || link.getAttribute('data-page-transition') === 'back') {
        return 'back';
      }

      return 'forward';
    }

    function clearEnterClasses(root) {
      root.classList.remove(
        'is-page-entering',
        'is-page-entering--forward',
        'is-page-entering--back'
      );
    }

    function clearExitClasses(root) {
      root.classList.remove('is-page-exiting', 'is-page-exiting--forward', 'is-page-exiting--back');
    }

    function resetTransitionState() {
      var root = document.querySelector(ROOT_SELECTOR);
      if (!root) {
        return;
      }

      clearExitClasses(root);
      clearEnterClasses(root);
      document.documentElement.classList.remove('lk-page-transition-pending', 'lk-page-transition-back');
    }

    function initEnterTransition() {
      var mode = null;

      try {
        mode = sessionStorage.getItem(TRANSITION_KEY);
      } catch (error) {
        mode = null;
      }

      if (!mode) {
        return;
      }

      var root = document.querySelector(ROOT_SELECTOR);
      if (!root) {
        return;
      }

      try {
        sessionStorage.removeItem(TRANSITION_KEY);
      } catch (error) {}

      document.documentElement.classList.remove('lk-page-transition-pending', 'lk-page-transition-back');

      if (prefersReducedMotion()) {
        return;
      }

      root.classList.add('is-page-entering', 'is-page-entering--' + mode);

      window.setTimeout(function () {
        clearEnterClasses(root);
      }, DURATION_MS + 40);
    }

    function navigateWithTransition(url, direction) {
      var root = document.querySelector(ROOT_SELECTOR);

      if (!root || prefersReducedMotion()) {
        window.location.href = url;
        return;
      }

      try {
        sessionStorage.setItem(TRANSITION_KEY, direction);
      } catch (error) {}

      var navigated = false;

      function go() {
        if (navigated) {
          return;
        }
        navigated = true;
        window.location.href = url;
      }

      clearExitClasses(root);
      root.classList.add('is-page-exiting', 'is-page-exiting--' + direction);

      root.addEventListener(
        'animationend',
        function (event) {
          if (event.target === root) {
            go();
          }
        },
        { once: true }
      );

      window.setTimeout(go, DURATION_MS + 80);
    }

    document.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest('a[href]');
        if (!link) {
          return;
        }

        if (link.closest('.product-thumbnail')) {
          markShopReturnIfNeeded();
        }

        if (isShopScrollLink(link) && isSameDocumentShopLink(link)) {
          var shopSection = getShopTarget();
          if (!shopSection) {
            return;
          }

          event.preventDefault();

          if (prefersReducedMotion()) {
            shopSection.scrollIntoView({ behavior: 'auto', block: 'start' });
          } else {
            scrollToElement(shopSection);
          }

          updateShopHash();

          return;
        }

        if (!shouldPageTransition(link)) {
          return;
        }

        markShopReturnIfNeeded();
        event.preventDefault();
        navigateWithTransition(link.href, getTransitionDirection(link));
      },
      true
    );

    function onReady() {
      initEnterTransition();
      initShopReturnScroll();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onReady);
    } else {
      onReady();
    }

    window.addEventListener('popstate', handleShopPopstate);

    window.addEventListener('pagehide', function (event) {
      if (event.persisted) {
        resetTransitionState();
      }
    });

    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        resetTransitionState();
        initEnterTransition();
        initShopReturnScroll();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-thumbnail"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__lkProductThumbnailTouchInit) {
      return;
    }
    window.__lkProductThumbnailTouchInit = true;

    var PREVIEW_CLASS = 'is-touch-preview';
    var HOLD_MS = 120;
    var MOVE_TOLERANCE = 14;
    var SUPPRESS_ATTR = 'data-suppress-click';

    var activeLink = null;
    var holdTimer = null;
    var holdActivated = false;
    var startX = 0;
    var startY = 0;

    function isTouchLike() {
      return window.matchMedia('(hover: none), (pointer: coarse)').matches;
    }

    function isTouchPointer(event) {
      return event.pointerType === 'touch' || event.pointerType === 'pen';
    }

    function clearPreview(except) {
      document.querySelectorAll('.product-thumbnail.' + PREVIEW_CLASS).forEach(function (link) {
        if (link !== except) {
          link.classList.remove(PREVIEW_CLASS);
        }
      });
    }

    function clearHoldTimer() {
      if (holdTimer) {
        window.clearTimeout(holdTimer);
        holdTimer = null;
      }
    }

    function resetGesture() {
      clearHoldTimer();
      activeLink = null;
      holdActivated = false;
    }

    function getThumbnailLink(target) {
      if (!target || !target.closest) {
        return null;
      }

      var link = target.closest('a.product-thumbnail');
      if (!link || link.classList.contains('product-thumbnail--placeholder')) {
        return null;
      }

      return link;
    }

    function activatePreview(link) {
      holdActivated = true;
      clearPreview(link);
      link.classList.add(PREVIEW_CLASS);
    }

    document.addEventListener(
      'pointerdown',
      function (event) {
        if (!isTouchLike() || !isTouchPointer(event) || event.button !== 0) {
          return;
        }

        var link = getThumbnailLink(event.target);
        if (!link) {
          return;
        }

        resetGesture();
        activeLink = link;
        startX = event.clientX;
        startY = event.clientY;

        holdTimer = window.setTimeout(function () {
          if (activeLink === link) {
            activatePreview(link);
          }
        }, HOLD_MS);
      },
      { passive: true }
    );

    document.addEventListener(
      'pointermove',
      function (event) {
        if (!activeLink || holdActivated || !isTouchPointer(event)) {
          return;
        }

        var dx = event.clientX - startX;
        var dy = event.clientY - startY;

        if (dx * dx + dy * dy > MOVE_TOLERANCE * MOVE_TOLERANCE) {
          resetGesture();
        }
      },
      { passive: true }
    );

    document.addEventListener(
      'pointerup',
      function (event) {
        if (!activeLink || !isTouchPointer(event)) {
          return;
        }

        var link = activeLink;
        clearHoldTimer();

        if (holdActivated) {
          link.setAttribute(SUPPRESS_ATTR, 'true');
        }

        activeLink = null;
      },
      { passive: true }
    );

    document.addEventListener(
      'pointercancel',
      function () {
        resetGesture();
      },
      { passive: true }
    );

    document.addEventListener(
      'click',
      function (event) {
        if (!isTouchLike()) {
          return;
        }

        var link = getThumbnailLink(event.target);

        if (link && link.getAttribute(SUPPRESS_ATTR) === 'true') {
          event.preventDefault();
          link.removeAttribute(SUPPRESS_ATTR);
          return;
        }

        if (link && link.classList.contains(PREVIEW_CLASS)) {
          link.classList.remove(PREVIEW_CLASS);
          return;
        }

        if (!link) {
          clearPreview();
        }
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
